/* eslint-disable @typescript-eslint/no-explicit-any */

import { AuditTableCell } from "./audit-table-cell";

export const AuditTableV3 = ({ data, parentKey, keyValue }: any) => {
  return (
    <div className="float-left">
      <div className="text-[14px] min-w-[200px] w-full  bg-gray-100 font-semibold relative px-3 py-2">
        {keyValue}
      </div>

      {data.map((item: any, index: number) => {
        const isArray = Array.isArray(item);
        const itemData = isArray ? item?.[0] : item;
        return (
          <div className="w-full odd:bg-gray-50" key={index}>
            <AuditTableCell
              data={itemData.text}
              key={index}
              keyValue={keyValue}
              parentKey={`${parentKey}.${index}.text`}
              textType="text"
              feedback={itemData?.feedback}
            />
          </div>
        );
      })}
    </div>
  );
};
